'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'circle-half';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e110';
var svgPathData = ['M256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256L256 0z', 'M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;